var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.8125V5.625C15 4.29892 14.4732 3.02715 13.5355 2.08947C12.5979 1.15178 11.3261 0.625 10 0.625C8.67392 0.625 7.40215 1.15178 6.46447 2.08947C5.52678 3.02715 5 4.29892 5 5.625V7.8125H3.4375V12.8125C3.4375 16.4311 6.38141 19.375 10 19.375C13.6186 19.375 16.5625 16.4311 16.5625 12.8125V7.8125H15ZM6.25 5.625C6.25 4.63044 6.64509 3.67661 7.34835 2.97335C8.05161 2.27009 9.00544 1.875 10 1.875C10.9946 1.875 11.9484 2.27009 12.6517 2.97335C13.3549 3.67661 13.75 4.63044 13.75 5.625V7.8125H6.25V5.625ZM15.3125 12.8125C15.3125 15.7418 12.9293 18.125 10 18.125C7.0707 18.125 4.6875 15.7418 4.6875 12.8125V9.0625H15.3125V12.8125Z",
    fill: "#E53935"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/block-icon.477478ce8d8c1e58a4d52e9233bb43e6.svg";
export { ForwardRef as ReactComponent };